var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsAndConditionsFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.182,
    height: 20,
    viewBox: "0 0 16.182 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "draft_FILL0_wght400_GRAD0_opsz48",
    d: "M161.517,196a1.463,1.463,0,0,1-1.062-.45A1.431,1.431,0,0,1,160,194.5v-17a1.431,1.431,0,0,1,.455-1.05,1.463,1.463,0,0,1,1.062-.45h9.127l5.537,5.475V194.5a1.431,1.431,0,0,1-.455,1.05,1.463,1.463,0,0,1-1.062.45Zm8.369-13.85V177.5h-8.369v17h13.148V182.15Zm-8.369-4.65v0Z",
    transform: "translate(-160 -176)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsAndConditionsFile);
export default __webpack_public_path__ + "static/media/termsAndConditionsFile.7fd16c6d2169b90c6bc25570f4fa811a.svg";
export { ForwardRef as ReactComponent };